export default class GameObject{
    protected TAG = "";

    get tag(): string {
        return this.TAG;
    }
}